import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { useAssistantPulseQuery } from '@/hooks/useAssistantProactive';
import { useAssistantPanel } from './assistantPanelContext';

export function AssistantBriefChip() {
  const { t } = useTranslation('assistant');
  const { isOpen, requestBrief } = useAssistantPanel();
  const pulseQuery = useAssistantPulseQuery();
  const pulse = pulseQuery.data;
  if (pulse === undefined || pulse.isActive === false || isOpen) {
    return null;
  }
  const briefKind = pulse.brief.kind;
  if (briefKind === null || pulse.brief.status === 'hidden') {
    return null;
  }
  const labelKey =
    pulse.brief.status === 'ready'
      ? 'brief.chip.' + briefKind + 'Ready'
      : 'brief.chip.' + briefKind;
  return (
    <button
      type="button"
      onClick={function openBrief() {
        requestBrief(briefKind);
      }}
      className="flex items-center gap-1.5 h-9 px-3 rounded-full border border-zooborder bg-zoowhite text-sm font-medium text-zooindigo shadow-sm hover:bg-zoovpalelavender focus:outline-none focus-visible:ring-2 focus-visible:ring-zooprimary"
    >
      <Icon name={briefKind === 'morning' ? 'Sun' : 'Moon'} className="text-zooprimary" />
      {t(labelKey)}
    </button>
  );
}
